require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./benton-county-drug-court.json") })
        }
      }, "path---benton-county-drug-court");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---benton-county-drug-court!./.cache/json/benton-county-drug-court.json
// module id = 843
// module chunks = 231608221292675